import styled from "styled-components";


export const ToggleContainer = styled.label`
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
`;

export const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  opacity: 0;
  width: 0;
  height: 0;
`;

export const Slider = styled.span`
  position: absolute;
  cursor: pointer;
  inset: 0;
  background-color: ${props => (props.checked ? 'white' : '#37474f')};
  transition: 0.4s;
  border-radius: 34px;
`;

export const IconBall = styled.span`
  position: absolute;
  height: 22px;
  width: 22px;
  bottom: 4px;
  left: ${props => (props.checked ? '34px' : '4px')};
  background-color: ${props => (props.checked ? '#fdd835' : 'white')};;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.4s;
  font-size: 14px;
  cursor: pointer;
  user-select: none;
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; 
`;